<footer class="text-center">
    <strong>ver. 3.11.7</strong><br>
    <p>Istituto di Linguistica Computazionale "A. Zampolli" CNR - Pisa Italy</p>
    <a href="http://www.ilc.cnr.it/" target="_blank" rel="noopener noreferrer">ILC-CNR</a>
</footer>